// 迅雷11 使用的API
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export default {
    call(func) {
        return __awaiter(this, void 0, void 0, function* () {
            if (window.native &&
                window.native.CallNativeFunction &&
                func &&
                typeof func === 'string') {
                return new Promise((resolve, reject) => {
                    window.native.CallNativeFunction(func, (...args1) => {
                        if (args1.length <= 1) {
                            reject('not allow');
                        }
                        console.warn('callNative result: ', args1);
                        resolve(args1.slice(1));
                    });
                });
            }
            else {
                return undefined;
            }
        });
    },
    on(eventname, fn) {
        if (window.native && window.native.AttachNativeEvent && eventname) {
            return window.native.AttachNativeEvent(eventname, (...args) => {
                console.warn('on fire event: ', eventname);
                fn && fn(...args);
            });
        }
    },
    off(eventName, id) {
        if (window.native && window.native.DetachNativeEvent && eventName) {
            return window.native.DetachNativeEvent(eventName, id);
        }
    },
};
// 调用客户端保存取回云盘文件
export function callPCSave({ files, userId, fromShare, shareId, passCodeToken, shareUserId, from, }) {
    return fetch("http://127.0.0.1:28317/yun_fetch_back/", {
        method: "post",
        headers: { "content-type": "application/x-www-form-urlencoded" },
        body: JSON.stringify({
            files,
            userId,
            fromShare,
            shareId,
            passCodeToken,
            shareUserId,
            from,
        }),
    });
}
//# sourceMappingURL=data:application/json;base64,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